var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacePledgeLogoBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420 58",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "PlacePledge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 38,
    fill: "#93c5fd",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif",
    fontSize: 26,
    fontWeight: 1000,
    letterSpacing: 10,
    textAnchor: "end"
  }, "PLACE"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 29,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 29h30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 13c6 5 6 27 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 13c-6 5-6 27 0 32"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 23,
    r: 2.6,
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 38,
    fill: "#93c5fd",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif",
    fontSize: 26,
    fontWeight: 1000,
    letterSpacing: 10
  }, "PLEDGE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacePledgeLogoBold);
export default __webpack_public_path__ + "static/media/place-pledge-logo-bold.304538547173ec1e53476d66c48bb899.svg";
export { ForwardRef as ReactComponent };